/**
 * LcSelect — app-wide React-Select wrapper.
 *
 * React-Select is searchable by default, which renders an editable text input
 * inside the control — producing a blinking text caret + I-beam cursor that
 * makes a click-to-open dropdown look like a text field.
 *
 * This wrapper defaults the dropdowns to non-searchable (click-to-select), so
 * there is no editable input and therefore no caret. Pass `isSearchable` on an
 * individual usage to re-enable type-ahead where it's genuinely needed.
 */
import React from 'react';
import Select from 'react-select';

const LcSelect = (props) => <Select isSearchable={false} {...props} />;

export default LcSelect;
